import { v4 as uuidv4 } from "uuid";
import { HIDE_MESSAGE, SHOW_MESSAGE } from "../../constants/ActionTypes";

export const showMessage = (payload) => ({
  type: SHOW_MESSAGE,
  payload: { ...payload, id: uuidv4() },
});
export const hideMessage = (payload) => ({ type: HIDE_MESSAGE, payload });
